import Swiper from 'swiper';
import { Pagination, Controller, Navigation } from 'swiper/modules';

export default () => ({
	init() {
		this.initialiseCarousel();
	},
	initialiseCarousel() {
		let timeout;

		new Swiper(this.$refs.image, {
			modules: [Pagination, Controller, Navigation],
			slidesPerView: 3,
			spaceBetween: 22,
			centeredSlides: false,
			autoHeight: false,
			grabCursor: true,
			initialSlide: 0,
			a11y: {
				enabled: true,
				prevSlideMessage: 'Previous item in the list',
				nextSlideMessage: 'Next item in the list',
			},
			// If we need pagination
			pagination: {
				el: this.$refs.pagination,
				clickable: true,
			},
			navigation: {
				nextEl: this.$refs.next,
				prevEl: this.$refs.prev,
			},
			breakpoints: {
				1: {
					slidesPerView: 1,
					spaceBetween: 22,
				},
				768: {
					slidesPerView: 4,
				},
				1024: {
					slidesPerView: 5,
					spaceBetween: 22,
				},
			},
			on: {
				lazyImageReady() {
					clearTimeout(timeout);

					timeout = setTimeout(() => {
						this.update();
						this.updateSlides();
					}, 100);
				},
			},
		});
	},
});
